import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import AnimateHeight from 'react-animate-height'
import * as R from 'ramda'

import Panel from '../../../UniformComponents/Panel'
import Button from '../../../UniformComponents/Button'
import SearchInput from '../../SearchInput'
import DebugControl from '../../DebugControl'

import './search-layout.scss'

@observer
class SearchLayout extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showFilterPanel: (!!props?.hideFilterAccordion || window.innerWidth > 992),
            showGuideAccordion: !!props.showGuideAtInit,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.checkOverflow)
    }

    // find height diff of main-menu on overflow
    checkOverflow = () => {
        const { innerWidth } = window
        if (innerWidth > 992) {
            this.setState({ showFilterPanel: true })
        } else this.setState({ showFilterPanel: !!this.props.hideFilterAccordion || false })
    }

    toggleFilterPanel = () => {
        if (window.innerWidth > 992) return

        this.setState((prevState) => ({
            showFilterPanel: !prevState.showFilterPanel,
        }))
    }

    toggleGuide = () => {
        this.setState((prevState) => ({
            showGuideAccordion: !prevState.showGuideAccordion
        }))
    }

    renderPageTitle = (pageTitle, showFilterPanel, hideFilterAccordion, store) => (
        <div className="heading">
            <div
                className="heading"
                style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                onClick={(e) => {
                    !hideFilterAccordion ? this.toggleFilterPanel() : () => {}
                }}
            >
                <h3>{pageTitle}</h3>

                {!hideFilterAccordion && (
                    <Fragment>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="filter-icon fa-regular fa-bars-filter" />
                            <p className="filter-text">Filters</p>
                            <i className={`panel-toggle-icon fa-regular ${showFilterPanel ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                        </div>
                    </Fragment>
                )}
            </div>

            {pageTitle === 'Questions' && store && (
                <div style={{ minHeight: 20, width: '100%' }}>
                    <DebugControl store={store} />
                </div>
            )}
        </div>
    )

    renderGuideAccordion = (showGuideAccordion, renderGuide) => (
        <Fragment>
            <hr className="heading-divider" />
            <div className="guide-accordion">
                <div
                    className="header"
                    onClick={this.toggleGuide}
                >
                    <i className="fa-solid fa-circle-info" />
                    <p>Getting started guide</p>
                    <i className={`fa-light ${showGuideAccordion ? 'fa-square-chevron-up' : 'fa-square-chevron-down'}`} />
                </div>
                <AnimateHeight
                    className="guide-content"
                    duration={250}
                    height={showGuideAccordion ? 'auto' : 0}
                >
                    <hr className="divider" />
                    {renderGuide()}
                </AnimateHeight>
            </div>
        </Fragment>
    )

    renderResetBtn = (resetFilter) => (
        <div className="reset-wrapper">
            <hr className="reset-divider" />
            <Button
                cssClass="reset-btn"
                icon="fa-regular fa-arrows-rotate"
                label={i18n.t('reset_filter', 'Reset filters')}
                onClick={resetFilter}
            />
        </div>
    )

    render() {
        const {
            pageTitle, renderFilterOptions, renderButtons, store,
            renderTablePanel, renderGuide, searchStore, hideFilterAccordion,
        } = this.props
        const { showGuideAccordion, showFilterPanel } = this.state

        if (R.pathOr(false, ['searchLoading'], searchStore)) {
            return (
                <div
                    className="loader"
                    style={{
                        color: 'rgba(57,183,183, 1)',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                    }}
                />
            )
        }

        return (
            <div className="search-container">
                <div className="left-container">
                    <Panel cssClass="filter-panel overflow-visible">
                        {this.renderPageTitle(pageTitle, showFilterPanel, hideFilterAccordion, store)}
                        {renderGuide && this.renderGuideAccordion(showGuideAccordion, renderGuide)}
                        {!!renderFilterOptions
                            && (
                                <AnimateHeight
                                    className="filter-wrapper"
                                    duration={250}
                                    height={showFilterPanel ? 'auto' : 0}
                                    contentClassName="filter-content"
                                >
                                    {renderFilterOptions()}
                                    {R.pathOr(false, ['resetFilter'], searchStore) && this.renderResetBtn(searchStore.resetFilter)}
                                </AnimateHeight>
                            )}
                    </Panel>
                </div>
                <div className="right-container">
                    <Panel cssClass="search-panel">
                        <div className="left">
                            <SearchInput
                                ref={(s) => { searchStore.searchModule = s }}
                                onChange={searchStore.search}
                            />
                        </div>
                        {!!renderButtons
                            && (
                                <div className="search-panel-right">
                                    {renderButtons()}
                                </div>
                            )}
                    </Panel>
                    <Panel cssClass="table-panel">
                        {renderTablePanel()}
                    </Panel>
                </div>
            </div>
        )
    }
}

export default SearchLayout
